import { useStateManager } from "@bcm-dev/bcms-vite";
import CustomSelect, { CustomSelectItem } from "components/custom-ui/CustomSelect";
import DateSelect from 'components/custom-ui/DateSelect';
import { TableBody, TableView } from 'components/shared';
import { UIAmountInput, UITextInput } from 'components/ui';
import React from 'react';

/**
 * @function TASPositivePayAddChecksDesktopView
 * @return {React.Component}
 * @exported true
 * @description The TAS Positive Pay Add Check desktop content view.
 */
export default function TASPositivePayAddChecksDesktopView(props) {
      const { data, ui, onChange } = useStateManager();
    
      const rows = data.editCheckForms.reduce((acc, item, index) => {
        acc.push(
          <tr key={ item.id } className="table-item-container">
            <td className="table-item-view">
              <DateSelect active={ ui.editCheckForms[index].issuedDate.isActive } enablePast={ true } value={ item.issuedDate } onChange={ onChange(item.id, "issuedDate") } />
            </td>
            <td className="table-item-view">
              <UITextInput value={ item.checkNumber } onChange={ onChange(item.id, "checkNumber") } />
            </td>
            <td className="table-item-view">
              <UIAmountInput className="amount-field" value={ item.amount } onChange={ onChange(item.id, "amount") } />
            </td>
            <td className="table-item-view">
              <UITextInput value={ item.payee } onChange={ onChange(item.id, "payee") } />
            </td>
            <td className="table-item-view">
              <UITextInput value={ item.referenceNumber } onChange={ onChange(item.id, "referenceNumber") } />
            </td>
            <td className="table-item-view">
              <CustomSelect active={ ui.editCheckForms[index].type.isActive } value={ item.type } onChange={ onChange(item.id, "type") }>
                  <CustomSelectItem value="issue">Issue</CustomSelectItem>
                  <CustomSelectItem value="stop">Stop</CustomSelectItem>
                  <CustomSelectItem value="void">Void</CustomSelectItem>
              </CustomSelect>
            </td>
          </tr>
        );
        return acc;
      }, []);

    return (
        <div className="flex-container table-view-container show-on-desktop">
        <TableView className="tas-positive-pay-add-check-table">
            <thead className="table-column-container">
            <tr>
                <th className="text-left table-column-view">Issued Date</th>
                <th className="text-left table-column-view">Check Number</th>
                <th className="text-left table-column-view">Amount</th>
                <th className="text-left table-column-view">Payee (Optional)</th>
                <th className="text-left table-column-view">Reference Number (Optional)</th>
                <th className="text-left table-column-view">Type</th>
            </tr>
            </thead>
            <TableBody>{ rows } </TableBody>
        </TableView>
        </div>
    );
}